import { queryOptions } from "@tanstack/react-query";
import {
  getPayrollSettings,
  getPayrollClasses,
  getClassCommissionDetail,
  getPayrollRecurringItems,
  getPayrollStaff,
  getPayrollRuns,
  getPayrollRun,
  getPayrollPayslip,
  getPayrollRunPayslips,
} from "hooks/api/payroll";

export const payrollSettingsOptions = () =>
  queryOptions({ queryKey: ["payroll", "settings"], queryFn: getPayrollSettings });

export const payrollClassesOptions = () =>
  queryOptions({ queryKey: ["payroll", "classes"], queryFn: getPayrollClasses });

export const classCommissionDetailOptions = (classTypeId?: string) =>
  queryOptions({
    queryKey: ["payroll", "class-settings", classTypeId],
    queryFn: () => getClassCommissionDetail(classTypeId!),
    enabled: !!classTypeId,
  });

export const payrollRecurringItemsOptions = () =>
  queryOptions({ queryKey: ["payroll", "recurring-items"], queryFn: getPayrollRecurringItems });

export const payrollStaffOptions = (includeDeparted = false) =>
  queryOptions({
    queryKey: ["payroll", "staff", includeDeparted],
    queryFn: () => getPayrollStaff(includeDeparted),
  });

export const payrollRunsOptions = () =>
  queryOptions({ queryKey: ["payroll", "runs"], queryFn: getPayrollRuns });

export const payrollRunOptions = (runId?: string) =>
  queryOptions({
    queryKey: ["payroll", "runs", runId],
    queryFn: () => getPayrollRun(runId!),
    enabled: !!runId,
  });

export const payrollPayslipOptions = (runId?: string, lineId?: string) =>
  queryOptions({
    queryKey: ["payroll", "runs", runId, "lines", lineId, "payslip"],
    queryFn: () => getPayrollPayslip({ runId: runId!, lineId: lineId! }),
    enabled: !!runId && !!lineId,
  });

export const payrollRunPayslipsOptions = (runId?: string) =>
  queryOptions({
    queryKey: ["payroll", "runs", runId, "payslips"],
    queryFn: () => getPayrollRunPayslips(runId!),
    enabled: !!runId,
  });
